import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogConfirmacionComponent } from '../../../../components/shared/dialog-confirmacion/dialog-confirmacion.component';
import { DialogProcesandoComponent } from '../../../../components/shared/dialog-procesando/dialog-procesando.component';
import { ErroresService } from '../../../../core/services/errores.service';
import { IboxtoolsItemUnico } from '../../../../models/iboxtools-item-unico';
import { NovedadesTiempos } from '../../../../models/novedadesTiempos';
import { NovedadesTiemposService } from '../../../../services/novedades-tiempos.service';
import { NovedadesTiemposDetalleComponent } from '../novedades-tiempos-detalle/novedades-tiempos-detalle.component';
import { GruposLiquidacionService } from '../../../../services/gruposLiquidacion.service';
import { MomentSetService } from '../../../../core/services/moment-set.service';

@Component({
  selector: 'app-novedades-tiempos',
  templateUrl: './novedades-tiempos.component.html',
  styleUrls: ['./novedades-tiempos.component.css']
})
export class NovedadesTiemposComponent implements OnInit {

  @Input() personalId;
  @Input() fechaslist;
  @Input() gruposLiquidaciones;
  disabledEditing: boolean;
  novedadTiempo: NovedadesTiempos;
  verDetalle: boolean = false;
  isEditing: boolean = false;
  permisoEdicion: boolean = false;
  habilitarFormDetalle: boolean = false;
  MensajeError: string;

  //Control ibox
  novedadesTiempoHistoryList: any;
  novedadesTiempoList: NovedadesTiempos[];
  toolboxEnabled: boolean = false;
  onlyNew: boolean = true;
  novedadesTiempos: NovedadesTiempos[];
  buscando: boolean;
  cortarRegistro: boolean = false;

  ingreso: any;
  desdeAnterior: boolean = false;
  anteriorRetroactividad: boolean = false;
  novedadesInvalida: boolean = false;

  public cargaCompleta: boolean = false;

  @ViewChild('ChildNovedadTiempoDetalle') novedadTiempoDetalle: NovedadesTiemposDetalleComponent;

  constructor(private novedadesTiempoService: NovedadesTiemposService,
    private dialog: MatDialog,
    private erroresService: ErroresService,
    private snackBar: MatSnackBar, 
    private gruposLiquidacionService: GruposLiquidacionService,
    private momentService: MomentSetService) { }

  ngOnInit(): void
  {
    this.obtenerNovedades(false);
    
    this.verPermiso();
  }

  async verPermiso() : Promise<void>  {
    let permisos = localStorage.getItem("Permisos");
    if (permisos.includes("Editar Novedades Tiempos")) this.permisoEdicion = true;
  }

  obtenerNovedades(agrupar)
  {
    this.buscando = true;
    this.novedadesTiempoService.getByPersonal(this.personalId, agrupar).subscribe(
      data =>
      {
        data.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.novedadesTiempos = data;
        this.buscando = false;
        this.cargaCompleta = true;
      },
      error =>
      {
        this.cargaCompleta = true;
        this.buscando = false;
        console.log(error);
      });
  }

  ngOnChanges(changes: SimpleChanges): void
  {
    //throw new Error("Method not implemented.");
  }

  async OnVisualizarDetalle(novedad)
  {
    if (novedad.id != 0)
    {
      this.obtenerHistorial(novedad);
    }
    else
    {
      if (await this.verEstadoNomina())
      {
        this.verDetalle = true;
        this.novedadTiempo = novedad;
        this.habilitarEdicion();
      }
    }
  }

  async OnDeleteChange(event)
  {
    if (await this.validarEdicion(this.novedadTiempo))
    {
      this.MensajeError = "";
      let dialogRef = this.dialog.open(DialogConfirmacionComponent, {
        width: '400px',
      });

      dialogRef.componentInstance.mensaje = "¿Está seguro de eliminar?";

      dialogRef.afterClosed().subscribe(result =>
      {
        if (result != null && result)
        {
          let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
            width: '400px'
          });
          dialogProcesandoRef.componentInstance.Mensaje = "Eliminando...";

          this.novedadesTiempoService.eliminar(this.novedadTiempo.id).subscribe(
            response =>
            {
              this.snackBar.open("Eliminado correctamente.", "OK", { duration: 10000 });
              setTimeout(function ()
              {
                dialogProcesandoRef.close();
              });

              let novedadTiempo = this.novedadesTiempoList.filter(d => d.id != this.novedadTiempo.id)[0];
              if (novedadTiempo == undefined)
              {
                this.volverAtras();
              }

              this.obtenerHistorial(novedadTiempo);
            },
            error =>
            {
              if (error.status == 400)
              {
              }
              else
              {
                this.erroresService.MostrarErrorByStatus(error, "Error al eliminar");
              }
              dialogProcesandoRef.close();
            });
        }
      });
    }
  }

  OnBackChange()
  {
    this.volverAtras();
  }

  async OnEditChange()
  {
    if (await this.validarEdicion(this.novedadTiempo))
    {
      this.habilitarEdicion();
      var $this = this;
      setTimeout(function ()
      {
        $this.novedadTiempoDetalle.form.controls['fecha'].disable();
      });
    }
  }

  OnPeriodChange(index: number)
  {
    let novedad = this.novedadesTiempoList.find(d => d.id == index);
    this.novedadTiempo = novedad;
    this.MensajeError = "";
  }

  OnCancelChange(e: boolean)
  {
    this.novedadTiempoDetalle.setearForm(this.novedadTiempo);
    this.deshabilitarEdicion();
  }

  OnSaveChange(e: boolean)
  {
    if (this.validarDatos())
    {
      let dialogProcesandoRef = this.dialog.open(DialogProcesandoComponent, {
        width: '400px'
      });
      dialogProcesandoRef.componentInstance.Mensaje = "Guardando...";

      let formulario = this.novedadTiempoDetalle.form.getRawValue();

      let datosNov: NovedadesTiempos = {
        id: formulario.id,
        personal: formulario.personal,
        fecha: this.momentService.saveDateServer(formulario.fecha, false),
        motivo: formulario.motivo,
        unidadMedida: formulario.unidadMedida,
        cantidad: formulario.cantidad,
        importe: formulario.importe,
        codigosNomina: formulario.codigosNomina
      };

      this.novedadesTiempoService.guardar(datosNov, this.cortarRegistro).subscribe(
        novedadT =>
        {
          novedadT.fecha = this.momentService.convertDateServer(novedadT.fecha);

          setTimeout(function ()
          {
            dialogProcesandoRef.close();
          });

          this.snackBar.open("Novedad guardada", "OK", { duration: 10000 });

          this.deshabilitarEdicion();

          this.obtenerHistorial(novedadT);
          //TODO. Modificar la forma de obtener la fecha sin el TimeZone
          //novedadPeriodo.desde = novedadPeriodo.desde.replace('Z', '');
          this.novedadTiempoDetalle.setearForm(novedadT);
        },
        error =>
        {
          dialogProcesandoRef.close();

          if (error.status === 400)
          {
            this.MensajeError = this.erroresService.MostrarError400(error);
          }
          else
          {
            this.erroresService.MostrarErrorByStatus(error, "Error al guardar");
          }
        });
    }
  }

  async OnNewChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.habilitarEdicion();
      this.novedadTiempoDetalle.form.controls['id'].setValue(0);
    }
  }

  async OnCutChange(e: boolean)
  {
    if (await this.verEstadoNomina())
    {
      this.cortarRegistro = true;
      this.habilitarEdicion();

      var $this = this;
      setTimeout(function ()
      {
        $this.novedadTiempoDetalle.form.controls['hasta'].disable();
      });
    }
  }

  private deshabilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = true;
    this.isEditing = false;
    this.habilitarFormDetalle = false;
    this.cortarRegistro = false;
  }

  private habilitarEdicion()
  {
    this.MensajeError = "";
    this.disabledEditing = false;
    this.isEditing = true;
    this.habilitarFormDetalle = true;
  }

  private volverAtras()
  {
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    this.MensajeError = "";
    this.novedadesTiempoHistoryList = [];
    this.novedadesTiempoList = [];
    this.habilitarFormDetalle = false;
    this.verDetalle = false;
    this.obtenerNovedades(false);
  }

  private obtenerHistorial(novedadTiempo: NovedadesTiempos)
  {
    this.novedadesTiempoService.getHistoryByClase(novedadTiempo.personal, novedadTiempo.codigosNomina).subscribe(
      novedades =>
      {
        novedades.forEach((currentValue,index,arr) => {
          currentValue.fecha = this.momentService.convertDateServer(currentValue.fecha);
        });

        this.novedadesTiempoHistoryList = [];
        novedades.forEach(d =>
        {
          let item = new IboxtoolsItemUnico(d);
          this.novedadesTiempoHistoryList.push(item);
        });

        this.novedadesTiempoList = novedades;
        this.verDetalle = true;
        this.novedadTiempo = novedadTiempo;
      },
      error =>
      {
        console.log(error);
      });
  }

  private validarDatos(): boolean
  {
    this.MensajeError = "";
    
    if (this.novedadTiempoDetalle.form.get("codigosNomina").value == 0)
    {
      this.novedadTiempoDetalle.form.get("codigosNomina").setErrors({ 'invalid': true });
    }

    this.ingreso = this.fechaslist.find(d => d.claseFechaNavigation.codigo == "01");
    let desde = this.novedadTiempoDetalle.form.get("fecha").value.toDateString();
    let hoy = new Date()

    let fingreso = new Date(this.ingreso.desde).toDateString();
    this.desdeAnterior = false;
    this.anteriorRetroactividad = false;
    if (Date.parse(desde) < Date.parse(fingreso))
    {
      this.desdeAnterior = true;
      this.novedadTiempoDetalle.form.get("fecha").setErrors({'desdeAnterior': true });
    } else {
      //valida que la fecha desde no sea anterior a la fecha de retroactividad del grupo de liquidacion vigente
      if (this.gruposLiquidaciones.periodoRetroactividad != null)
      {
        let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
        if (Date.parse(desde) < Date.parse(fretro) )
        {
          this.anteriorRetroactividad = true;
          this.novedadTiempoDetalle.form.get("fecha").setErrors({'anteriorRetroactividad': true });
        }
      }
    }

    if (this.novedadTiempoDetalle.form.valid)
    {
      return true;
    }
    else
    {
      this.novedadTiempoDetalle.form.markAllAsTouched();
      return false;
    }
  }

  private async verEstadoNomina() : Promise<boolean>
  {
    let estadoValido = true;
    this.gruposLiquidaciones = await this.gruposLiquidacionService.GetVigenteByPersonal(this.personalId).toPromise();
    if (this.gruposLiquidaciones.estadoActual == 1) {
      estadoValido = false;
      this.snackBar.open("Acción no válida durante el Cálculo de la Nómina. Actualice el registro de gestión.", "OK", { duration: 10000 });
    }
    return estadoValido;
  }

  private validacionRetro(desde) : boolean
  {
    let anterior = false;
    
    if (this.gruposLiquidaciones.periodoRetroactividad != null)
    {
      let fretro = new Date(this.gruposLiquidaciones.periodoRetroactividadNavigation.fechaDd).toDateString();
      if (Date.parse(desde) < Date.parse(fretro) )
      {
        anterior = true;
        this.snackBar.open("Acción no válida porque es anterior al límite de retroactividad.", "OK");
      }
    }
    return anterior;
  }

  private async validarEdicion(row) : Promise<boolean>
  {
    let edita = true;
    
    let estadoValido = await this.verEstadoNomina();
    if (estadoValido == false) edita = false;
    
    if(edita)
    {
      let anterior = this.validacionRetro(row.desde);
      if(anterior) edita = false;  
    }
    return edita;
  }
}
